export default "__VITE_ASSET__BI14IQR8__"